import { z } from "zod";

export const schema = z.object({
	id_centrocusto: z.number().int("Campo id_empresa é obrigatorio"),
	id_funcionario: z.number().int("Campo id_funcionario é obrigatorio"),
	nome: z.string().min(1, "Descrição do centro custo é obrigatório"),
	codigo: z.string().nullable(),
	ativo: z.boolean(),
	obs: z.string().nullable(),
	padrao: z.string().nullable(),
});
